import { HostDisintermediationBanner } from "@ps-design-system/components/HostDisintermediation";

import useHostDisintermediation from "../hooks/useHostDisintermediation";
import useHostHubData from "../hooks/useHostHubData";
import useHostHubVatAttention from "../hooks/useHostHubVatAttention";

import HostHubBannerCarousel from "./HostHubBannerCarousel.tsx";
import HostHubBookingRequestsAndInquiriesItem from "./HostHubBookingRequestsAndInquiriesItem.tsx";
import HostHubBookingUpdateRequestsItems from "./HostHubBookingUpdateRequestsItems.tsx";
import HostHubOverviewEmptyState from "./HostHubOverviewEmptyState.tsx";
import HostHubOverviewHeader from "./HostHubOverviewHeader.tsx";
import HostHubPausedListingsItem from "./HostHubPausedListingsItem.tsx";
import HostHubRecommendedSection from "./HostHubRecommendedSection.tsx";
import HostHubUnreadMessagesItem from "./HostHubUnreadMessagesItem.tsx";
import HostHubUpcomingPanel from "./HostHubUpcomingPanel";
import HostHubVatAttentionItem from "./HostHubVatAttentionItem.tsx";

const HostHubOverview = () => {
  const {
    bookingRequestsAndInquiries,
    hasAnyTodo,
    isLoading,
    pausedListings,
    reviewBookingUpdates,
    unreadMessages,
  } = useHostHubData();

  const hasBookingRequestsAndInquiries =
    bookingRequestsAndInquiries.card.isEligible;
  const hasBookingUpdateRequests = reviewBookingUpdates.cards.some(
    ({ isEligible }) => isEligible,
  );
  const hasUnreadMessages = unreadMessages.card.isEligible;

  const vatAttention = useHostHubVatAttention();
  const shouldShowEmptyState =
    !isLoading &&
    !vatAttention.isLoading &&
    !hasAnyTodo &&
    !vatAttention.isVisible;

  const hostDisintermediation = useHostDisintermediation();

  const hostDisintermediationElement = hostDisintermediation.showBanner ? (
    <HostDisintermediationBanner
      level={hostDisintermediation.level}
      onConsent={hostDisintermediation.handleConsent}
      className="tw-mb-24"
    />
  ) : null;
  // Paused-by-Peerspace cards always sit at the very top of Top priority.
  const pausedListingsItem = pausedListings.isEligible ? (
    <HostHubPausedListingsItem />
  ) : null;
  const bookingRequestsAndInquiriesItem = hasBookingRequestsAndInquiries ? (
    <HostHubBookingRequestsAndInquiriesItem />
  ) : null;
  const bookingUpdateRequestsItems = hasBookingUpdateRequests ? (
    <HostHubBookingUpdateRequestsItems />
  ) : null;
  const unreadMessagesItem = hasUnreadMessages ? (
    <HostHubUnreadMessagesItem />
  ) : null;
  const overviewEmptyState = shouldShowEmptyState ? (
    <HostHubOverviewEmptyState />
  ) : null;

  return (
    <div className="tw-mx-auto tw-flex tw-w-full tw-flex-col tw-gap-[32px] lg:tw-flex-row">
      <div className="tw-flex tw-w-full tw-flex-col tw-gap-[16px] lg:tw-max-w-[704px] lg:tw-flex-1">
        {hostDisintermediationElement}
        <HostHubOverviewHeader />
        <div className="tw-flex tw-flex-col tw-gap-[8px]">
          {pausedListingsItem}
          {vatAttention.isVisible && <HostHubVatAttentionItem />}
          {bookingRequestsAndInquiriesItem}
          {bookingUpdateRequestsItems}
          {unreadMessagesItem}
          {overviewEmptyState}
        </div>
        <HostHubBannerCarousel />
        <HostHubRecommendedSection />
      </div>
      <div className="tw-w-full lg:tw-w-[352px] lg:tw-shrink-0">
        <HostHubUpcomingPanel />
      </div>
    </div>
  );
};

export default HostHubOverview;
